

    <a href="{{imageUrl+imagePath}}" title="download" style="padding-left: 95%;
    font-size: 22px;"><i class="fa fa-download" ></i></a>
                   <span  (click)="goToBugDescription()" title="close" 
                   style="cursor: pointer;padding-left: 2%; font-size: 30px;color: red;"><i aria-hidden="true" >&times;</i></span>
     <img src="{{imageUrl+imagePath}}"  style="text-align:center;height:auto;width:auto;" >


